import { Button, SelectDropDown } from '@wot/components';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import { updateProfile } from '../../../reducers/profileSlice';
import Currencies from './currencies.json';
import { getCurrencyFromCode } from '../../../utils/getVisitorInfo';

export default function Settings() {
  // @ts-ignore
  const timezones = Intl.supportedValuesOf('timeZone');
  // @ts-ignore
  let currencies = Object.keys(Currencies).map((item) => `${item}(${Currencies[item].name_plural})`);
  const { profile } = useAppSelector((state) => state.profileSlice);
  const { currency: c } = useAppSelector((state) => state.visitorInfoSlice);
  const [lessonUpdates, setLessonUpdates] = useState(profile?.prefrences?.lessonUpdates || false);
  const [accountUpdates, setAccountUpdates] = useState(profile?.prefrences?.accountUpdates || false);
  const [currency, setCurrency] = useState(
    profile?.prefrences?.currency || {
      code: c.code,
      name: c.name,
      symbol: c.symbol
    }
  );
  const [timezone, setTimezone] = useState(
    profile?.prefrences?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
  );
  const dispatch = useAppDispatch();

  const onSave = async () => {
    await dispatch(
      updateProfile({
        prefrences: {
          lessonUpdates,
          accountUpdates,
          currency,
          timezone
        }
      })
    );
  };

  return (
    <div className="w-full h-full flex flex-col gap-5 pt-5 pb-20 md:pb-0">
      <div className="w-full flex flex-col gap-4 p-7 border border-neutralGray3 rounded-sm">
        <h1 className="text-lg font-semibold mb-2">Email Notifications</h1>

        <div className="w-full flex items-center">
          <p className="w-full md:w-1/5 text-sm whitespace-nowrap">Lesson Updates</p>
          <Toggle value={lessonUpdates} handleChange={(value) => setLessonUpdates(value)} />
        </div>

        <div className="w-full flex items-center">
          <p className="w-full md:w-1/5 text-sm whitespace-nowrap">Account Updates</p>
          <Toggle value={accountUpdates} handleChange={(value) => setAccountUpdates(value)} />
        </div>
      </div>

      <div className="w-full flex flex-col gap-4 p-7 border border-neutralGray3 rounded-sm">
        <h1 className="text-lg font-semibold mb-2">Currency Settings</h1>
        <div className="w-full flex flex-col md:flex-row md:items-center gap-2 md:gap-10">
          <p className="text-sm">Choose Currency</p>
          <div className="w-full max-w-[250px]">
            <SelectDropDown
              placeholder="Choose Currency"
              options={currencies}
              value={`${currency.code}(${currency.name})`}
              onChange={(value) => {
                let code = value.slice(0, 3);
                let x = getCurrencyFromCode(code);
                setCurrency(x);
              }}
              isSearchable
            />
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col gap-4 p-7 border border-neutralGray3 rounded-sm">
        <h1 className="text-lg font-semibold mb-2">Timezone</h1>
        <div className="w-full flex flex-col md:flex-row md:items-center gap-2 md:gap-10">
          <p className="text-sm">Choose Timezone</p>
          <div className="w-full max-w-[250px]">
            <SelectDropDown
              placeholder="Timezone"
              options={timezones}
              value={timezone}
              onChange={(value) => setTimezone(value)}
              isSearchable
            />
          </div>
        </div>
      </div>

      {/* <div className="w-full flex flex-col gap-4 p-7 border border-neutralGray3 rounded-sm">
        <div className="w-full flex items-center justify-between">
          <h1 className="text-lg font-semibold mb-2">Bank account details</h1>
          <p className="text-sm text-primary font-medium hover:font-bold cursor-pointer">+ Add Account</p>
        </div>

      </div> */}

      <div className="w-full h-full flex items-center justify-center">
        <div className="w-full max-w-[164px]">
          <Button block onClick={() => onSave()} text="Save" />
        </div>
      </div>
    </div>
  );
}

function Toggle({ value, handleChange }: { value: boolean; handleChange: (value: boolean) => void }) {
  const [toggle, setToggle] = useState(value);
  useEffect(() => {
    handleChange(toggle);
  }, [toggle]);
  return (
    <div
      onClick={() => setToggle(!toggle)}
      className={`relative w-12 h-6 rounded-full ${toggle ? 'bg-primary' : 'bg-gray-100'
        } transition-all duration-500 cursor-pointer p-1`}
    >
      <div
        className={`absolute top-[2px] ${toggle ? 'left-[55%]' : 'left-[2px]'
          } transition-all duration-500 w-5 h-5  rounded-full bg-white`}
      ></div>
    </div>
  );
}
